import BN from 'bignumber.js';
import moment from 'moment-timezone';

export default {
    methods: {
        formatAmount(value) {
            if (value === null || value === undefined || value === '') {
                return '0.00000000';
            }
            BN.set({ ROUNDING_MODE: BN.ROUND_DOWN });
            // Never show negative available/ledger amounts to customers (locked can exceed
            // balance in abnormal cases; BE clamps aube_available, FE must too as defense).
            return BN.max(new BN(value), 0).toFixed(8);
        },

        /**
         * Floor available balance at 0 for transfer/stake checks (same rule as formatAmount).
         * @param {string|number|null|undefined} value
         * @returns {string}
         */
        nonNegativeBalance(value) {
            if (value === null || value === undefined || value === '') {
                return '0';
            }
            return BN.max(new BN(value), 0).toString();
        },

        formatDateTime(value) {
            if (!value) {
                return '-';
            }
            return moment(value).tz('Asia/Tokyo').format('YYYY/MM/DD HH:mm:ss') + ' (JST)';
        },

        formatShortDateTime(value) {
            if (!value) {
                return null;
            }
            return moment(value).tz('Asia/Tokyo').format('YYYY/MM/DD HH:mm');
        },
        
        formatHash(value) {
            if (!value) {
                return '-';
            }
            const hash = String(value);
            if (hash.length <= 12) {
                return hash;
            }
            return `${hash.slice(0, 6)}...${hash.slice(-4)}`;
        },
    },
};
